export default __webpack_public_path__ + "static/media/9.246b2a4e.jpg";